<template>
  <div>
    <h1 class="page-header">{{ $t('event.event') }}</h1>
    <div class="row">
      <div
        class="col-md-5 col-sm-12"
        v-show="isStaff"
        :class="{ 'col-lg-3': isStaff }"
      >
        <ts-card>
          <ts-card-wrapper>
            <form-create
              @success_create="fetchData"
              :edit="edit_data"
              :leave="route_leave"
              @success_update="edit_data = ''"
              @cancel="fetchData"
            ></form-create>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div
        class="col-lg-9 col-md-7 col-sm-12"
        :class="{ 'col-lg-12': !isStaff }"
      >
        <ts-card>
          <ts-card-wrapper>
            <div class="row">
              <div
                class="col-lg-6 com-md-9 col-sm-12 d-flex justify-content-start"
              ></div>
              <div
                class="col-lg-6 com-md-3 col-sm-12 d-flex justify-content-end"
              >
                <ts-input
                  v-model="search"
                  :placeholder="$t('search')"
                  style="width: 300px"
                  class="ml-2"
                />
                <ts-button
                  v-show="isStaff"
                  outline
                  class="ml-2"
                  v-tooltip="$t('filter')"
                  @click.prevent="visible = true"
                >
                  <i class="fa fa-filter"></i>
                </ts-button>
              </div>
            </div>
          </ts-card-wrapper>
          <div class="overflow-auto">
            <ts-loading-banner :loading="exporting">
              <Table
                :columns="columns"
                :data="resources"
                :loading="loading"
                max-height="700"
                stripe
                highlight-row
                size="small"
              >
                <template slot-scope="{ row }" slot="branch_name_en">
                  {{ row.branch !== null ? row.branch.branch_name_en : '' }}
                </template>
                <template slot-scope="{ row }" slot="event_name">
                  {{ $store.getters.limitStringShow(row.event_name) }}
                </template>
                <template slot-scope="{ row }" slot="event_criteria">
                  {{ $store.getters.limitStringShow(row.event_criteria) }}
                </template>
                <template slot-scope="{ row }" slot="is_staff_event">
                  <span
                    v-if="row.is_staff_event == true"
                    style="text-align: center;"
                    >{{ $t('yes') }}</span
                  >
                  <span v-else style="text-align: center;">{{ $t('no') }}</span>
                </template>
                <template slot-scope="{ row }" slot="is_parent_event">
                  <span
                    v-if="row.is_parent_event == true"
                    style="text-align: center;"
                    >{{ $t('yes') }}</span
                  >
                  <span v-else style="text-align: center;">{{ $t('no') }}</span>
                </template>
                <template slot-scope="{ row }" slot="is_student_event">
                  <span
                    v-if="row.is_student_event == true"
                    style="text-align: center;"
                    >{{ $t('yes') }}</span
                  >
                  <span v-else style="text-align: center;">{{ $t('no') }}</span>
                </template>
                <template slot-scope="{ row }" slot="action">
                  <a
                    v-show="isStaff"
                    href="#"
                    v-tooltip="$t('edit')"
                    class="text-primary mr-2"
                    @click.prevent="edit(row)"
                  >
                    <i class="fas fa-edit"></i>
                  </a>
                  <a
                    v-show="isStaff"
                    href="#"
                    v-tooltip="$t('delete')"
                    class="text-danger"
                    @click.prevent="destroy(row)"
                  >
                    <i class="fas fa-spin fa-spinner" v-if="row._deleting"></i>
                    <i class="fas fa-trash" v-else></i>
                  </a>
                </template>
              </Table>
            </ts-loading-banner>
          </div>
          <div class="d-flex justify-content-between align-items-center p-15">
            <ts-pagination
              v-model="pagination"
              @navigate="fetchData"
            ></ts-pagination>
          </div>
        </ts-card>
      </div>
      <a-drawer
        :title="$t('filter')"
        placement="right"
        :closable="false"
        :visible="visible"
        @close="() => (visible = false)"
        :zIndex="1020"
        width="300px"
      >
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <ts-branch-filter @filter="value => (branch_id = value)" />
            </div>
          </div>
        </div>
      </a-drawer>
    </div>
  </div>
</template>
<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FormCreate from './form.vue'

export default {
  components: {
    FormCreate
  },
  name: 'event',
  props: ['editData'],
  data() {
    return {
      edit_data: this.editData,
      loading: false,
      route_leave: false,
      exporting: false,
      branch_id: [],
      visible: false
    }
  },
  created() {
    if (this.isParent) {
      this.branch_id = []
      this.branch_id.push(this.$store.state.selectedStudent.branch_id)
    } else {
      this.fetchData()
    }
  },
  computed: {
    ...mapState('event', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.event.search
      },
      set(newVal) {
        this.$store.commit('event/SET_SEARCH', newVal)
        this.$store.commit('event/RESET_CURRENT_PAGE')
      }
    },
    isStaff() {
      return this.$store.getters.isStaffLogin
    },
    isParent() {
      return this.$store.getters.isParentLogin
    },
    selectedStudent() {
      return this.$store.state.selectedStudent.student_id
    },
    columns() {
      return [
        {
          title: this.$t('event.branch'),
          slot: 'branch_name_en',
          minWidth: 80
        },
        { title: this.$t('event.name'), slot: 'event_name', minWidth: 220 },
        {
          title: this.$t('event.startdate'),
          key: 'event_start_date',
          minWidth: 80
        },
        {
          title: this.$t('event.enddate'),
          key: 'event_end_date',
          minWidth: 80
        },
        {
          title: this.$t('event.criteria'),
          slot: 'event_criteria',
          minWidth: 80
        },
        {
          title: this.$t('event.staff'),
          slot: 'is_staff_event',
          minWidth: 80,
          align: 'center'
        },
        {
          title: this.$t('event.parent'),
          slot: 'is_parent_event',
          minWidth: 80,
          align: 'center'
        },
        {
          title: this.$t('event.student'),
          slot: 'is_student_event',
          minWidth: 80,
          align: 'center'
        },
        {
          title: this.$t('actions'),
          key: 'action',
          slot: 'action',
          fixed: 'right',
          align: 'center',
          width: 100
        }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true

      this.$store
        .dispatch(
          'event/fetch',
          Object.assign(
            {
              branch_id: this.branch_id
            },
            { ...attributes }
          )
        )
        .then(() => (this.loading = false))
        .catch(error => {
          this.$toasted.error(error.message)
          this.loading = false
        })
    },

    edit(data) {
      this.route_leave = false
      this.edit_data = data
      this.$router.push(`/events/${data.event_id}`)
    },

    async destroy(record) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        record._deleting = true
        this.$store
          .dispatch('event/delete', record.event_id)
          .then(response => {
            this.$toasted.success(response.message)
            this.fetchData()
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
          .finally(() => {
            record._deleting = false
          })
      }
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500),
    branch_id: debounce(function(value) {
      this.fetchData({ branch_id: value })
    }, 500),
    selectedStudent: debounce(function() {
      if (this.isParent) {
        this.branch_id = []
        this.branch_id.push(this.$store.state.selectedStudent.branch_id)
      }
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'event-create') {
      this.$store.commit('event/RESET_STATE')
      this.fetchData()
      this.route_leave = true
    }
    next()
  }
}
</script>
